module.exports = __webpack_public_path__ + "static/media/break-image.62a1a938.svg";